<template>
  <div class="edelivery">
    <ba-header activeModule="E-Delivery"></ba-header>
    <div class="edelivery__content u-p4 main-content">
      <h2 class="c-heading__page u-mt4 u-pt2">E-Delivery</h2>
      <div class="edelivery__table">
        <div class="edelivery__filters u-mt4">
          <el-form inline>
            <el-form-item label="From" class="line-height-3"><el-date-picker v-model="range.from" type="date" format="MM/dd/yyyy" placeholder="Pick a print date"></el-date-picker></el-form-item>
            <el-form-item label="To" class="line-height-3"><el-date-picker  v-model="range.to" type="date" format="MM/dd/yyyy" placeholder="Pick a print date"></el-date-picker></el-form-item>
            <el-form-item label="E-Delivery Insured" class="line-height-3">
              <el-autocomplete
                custom-item="my-item"
                popper-class="my-autocomplete"
                v-model="fileInsuredName"
                :fetch-suggestions="queryPrimaryInsuredNameSearch"
                placeholder="Enter E-Delivery Insured"
                icon="edit"></el-autocomplete>
            </el-form-item>
            <el-form-item label="Policy Number" class="line-height-3">
              <el-autocomplete
                custom-item="my-item"
                popper-class="my-autocomplete"
                v-model="policyNumber"
                :fetch-suggestions="queryPolicyNumberSearch"
                placeholder="Enter Policy Number"
                icon="edit"></el-autocomplete>
            </el-form-item>
            <el-form-item><el-button @click="loadPage(1)" icon="el-icon-search">Filter</el-button></el-form-item>
            <el-button v-if="range.from !== '' || range.to !== '' || this.fileInsuredName !== '' || this.policyNumber !== ''" @click="clearFilter">Clear Filter</el-button>
          </el-form>
        </div>
        <div class="schedule-info u-mb3">
          <ba-edelivery-schedule-info @onManualEdeliveryOnlyUpdate="onManualEdeliveryOnlyUpdate"></ba-edelivery-schedule-info>
        </div>
        <el-button v-if="manualEdeliveryOnly" @click="openApprovalsDialog()" icon="el-icon-message">Open Approval Page</el-button>
        <el-button v-if="manualEdeliveryOnly" @click="loadPage(1)" icon="el-icon-refresh">Refresh</el-button>
        <div class="u-mt2 u-mb2 reports-info">
          <div>
            <el-checkbox @change="loadPage(1)" v-model="showProcessedOnly" class="">Only Show Deliverable Events</el-checkbox>
          </div>
          <div>
            <el-button @click="downloadXlsReport()">Download Report</el-button>
          </div>
        </div>
        <div class="u-mt3">
          <el-table v-loading="loading" ref="edeliveryTable" @sort-change="sortChange"
                    class="u-mt3 edelivery-table" :data="items"
                    :row-class-name="baEdeliverablesTableRowClassName">
            <el-table-column label="Policy Number" width="125">
              <template slot-scope="scope">
                <a :href="getPolicyDataFromRow(scope.row).url" target="_blank" title="Will open in new tab">
                  {{getPolicyDataFromRow(scope.row).policyNumber}}</a>
              </template>
            </el-table-column>
            <el-table-column label="Insured" width="250">
              <template slot-scope="scope">
                {{ extractInsuredFromRow(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Email Address" width="250">
              <template slot-scope="scope">
                {{ extractEmailFromRow(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Title">
              <template slot="header" slot-scope="scope">
                <el-popover
                    placement="top-start"
                    trigger="hover"
                    width="350">
                  <div slot="default" class="word-break--word">
                    <div>A document with the asterisk(*) indicates the user has opened it.</div>
                    <div class="u-mt2">The number in parenthesis denotes the number of times the user has opened or downloaded the document.</div>
                  </div>
                  <div slot="reference">
                    Title
                    <el-icon name="info"></el-icon>
                  </div>
                </el-popover>


              </template>
              <template slot-scope="scope">
                {{ extractLabelFromRow(scope.row) }}  {{ extractViewCountFromRow(scope.row) }}
              </template>
            </el-table-column>
            <el-table-column label="Print Date" width="120" sortable>
              <template slot-scope="scope">
                {{ extractPrintDateFromRow(scope.row) | moment('MM/DD/YYYY') }}
              </template>
            </el-table-column>
            <el-table-column label="Processed" class-name="edelivery-table__processed-column" width="190" sortable>
              <template slot-scope="scope">
                {{ extractProcessedDateFromRow(scope.row) | moment('MM/DD/YYYY hh:mm:ss A') }}
              </template>
            </el-table-column>
            <el-table-column label="Delivery Status" class-name="edelivery-table__delivery-status-column" width="200">
              <template slot-scope="scope">
                {{ eDeliveryStatusToHumanString(extractDeliveryStatusFromRow(scope.row)) }}
              </template>
            </el-table-column>
            <el-table-column type="expand">
              <template slot-scope="scope">
                <div v-if="(!scope.row.linked_user_events || !scope.row.linked_user_events.length) && (!scope.row.linked_edeliveries || !scope.row.linked_edeliveries.length)">File: {{ extractUnprocessedFileName(scope.row) }}</div>
                <div v-if="scope.row.linked_user_events"  class="linked-user-events-border"
                     v-for="userEvent in scope.row.linked_user_events">
                  <p><b>user:</b> {{userEvent.metadata.bc_contact.name}}</p>
                  <p><b>state:</b> {{userEvent.event_status}}</p>
                  <p><b>email:</b> {{userEvent.metadata.email}}</p>
                  <p><b>contact id:</b> {{userEvent.metadata.contact_id}}</p>
                  <div v-if="userEvent.linked_edeliveries">
                    <div class="linked-edeliverables-title">
                      <p><b>mailed deliverables: </b></p>
                    </div>
                    <div class="linked-edeliverables-body">
                      <p v-for="linked_edelivery in userEvent.linked_edeliveries">
                        <a :href="extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).url"
                           target="_blank" title="Will open in new tab">
                          {{extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).title}}</a>
                      </p>
                    </div>
                  </div>
                </div>
                <div v-if="scope.row.linked_edeliveries">
                    <div class="linked-edeliverables-title">
                      <p><b>deliverables: </b></p>
                    </div>
                    <div class="linked-edeliverables-body">
                      <p v-for="linked_edelivery in scope.row.linked_edeliveries">
                      <a :href="extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).url"
                         target="_blank" title="Will open in new tab">
                        {{extractTitleDataFromMetadata(linked_edelivery.edeliverable_metadata).title}}</a>
                      </p>
                    </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination class="u-mt4" :layout="paginationLayout"
                         :total="total" :page-size="perPage"
                         @current-change="loadPage">
          </el-pagination>
        </div>
      </div>
      <div class="edelivery__paginator">
      </div>
    </div>
    <ba-approval-dialog ref="baApprovalDialog"></ba-approval-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaCompanyImage from '@/modules/appearance/company-image.component'
import EdeliveryScheduleInfo from '@/components/edelivery.schedule.info.component.vue'
import BaApprovalDialog from '@/components/approval.dialog.component.vue'
import ElButton from 'element-ui/packages/button/src/button'
import axios from 'axios'
import config from '@/config'
import {humanizeEdeliveryStatus, getEdeliveryRowCssStyleByStatus, convertDateToYYYYMMDD} from '@/shared/misc.utils'

export default {
  components: {
    ElButton,
    BaCompanyImage,
    BaApprovalDialog,
    'ba-edelivery-schedule-info': EdeliveryScheduleInfo,
  },
  name: 'ba-edelivery',
  data () {
    return {
      companyId: this.$route.params.companyId,
      edeliveryUserEvents: {1: 0},
      range: {
        from: '',
        to: '',
      },
      items: [],
      loading: true,
      total: 0,
      perPage: 50,
      numPages: 0,
      selectedItems: [],
      showProcessedOnly: true,
      fileInsuredName: '',
      policyNumber: '',
      insuredsPolicyTuples: [],
      orderBy: '-status_update_timestamp',
      manualEdeliveryOnly: null
    }
  },
  beforeMount () {
    this.loading = true
    this.loadInitial()
  },
  computed: {
    ...mapGetters('shared', ['companyById']),
    paginationLayout () {
      let moreThan15Pages = this.numPages > 15
      return moreThan15Pages ? 'prev, pager, next, jumper' : 'prev, pager, next'
    },
  },
  methods: {
    onManualEdeliveryOnlyUpdate (newValue) {
      this.manualEdeliveryOnly = newValue
    },
    eDeliveryStatusToHumanString (status) {
      return humanizeEdeliveryStatus(status)
    },
    sortChange (sortProperties) {
      let column = sortProperties.column
      let columnName = column.label === 'Processed' ? 'status_update_timestamp': 'print_date'
      this.orderBy = column.order === 'descending' ? '-' + columnName : columnName
      this.loadPage(1)
    },
    openApprovalsDialog () {
      this.$refs.baApprovalDialog.showDialog({
        companyId: this.companyId,
        dateFrom: this.range.from,
        dateTo: this.range.to,
        adminMode: false,
        readOnlyDates: false,
      })
    },
    extractUnprocessedFileName (row) {
      let metadata = row.edeliverable_metadata
      if (metadata.file) {
        return metadata.file.title
      }

      if (metadata.form) {
        return metadata.form.title
      }

      return 'Unknown file name'
    },
    extractTitleFromMetadata (metadata) {
      return metadata.file ? metadata.file.title : metadata.form.title
    },
    getCompany () {
      return this.companyById(this.companyId)
    },
    extractTitleDataFromMetadata (metadata) {
      let company = this.getCompany()
      let title = metadata.file ? metadata.file.title : metadata.form.title
      let edeliverableBcId = metadata.file ? metadata.file.id : metadata.form.id
      return {
        url: company.britecore_url + '/gateway?file=core.uploads&method=getAttachment&id=' + edeliverableBcId,
        title: title
      }
    },
    getPolicyDataFromRow (row) {
      let policyEntity = row.entity_type === 'EDelivery' ? row.edeliverable_metadata.policy
        : row.linked_edeliveries[0].edeliverable_metadata.policy
      return {
        policyNumber: policyEntity.policy_number,
        url: this.getCompany().britecore_url + '/britecore/policies/information?policyId=' + policyEntity.id
      }
    },
    extractTitleFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return this.extractTitleFromMetadata(row.edeliverable_metadata)
      } else {
        return this.extractTitleFromMetadata(row.linked_edeliveries[0].edeliverable_metadata)
      }
    },
    extractViewCountFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return null
      } else {
        let viewCount = row.linked_edeliveries[0].view_count
        if (viewCount && viewCount > 0) {
          return `* (${viewCount})`
        }
        return null
      }
    },
    extractLabelFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        let metadata = row.edeliverable_metadata
        return metadata.file ? metadata.file.label : 'Form'
      } else {
        let metadata = row.linked_edeliveries[0].edeliverable_metadata
        return metadata.file ? metadata.file.label : 'Form'
      }
    },
    extractPrintDateFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return row.print_date
      } else {
        return row.linked_edeliveries[0].print_date
      }
    },
    extractProcessedDateFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return row.status_update_timestamp
      } else {
        return row.linked_edeliveries[0].status_update_timestamp
      }
    },
    extractInsuredFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return row.edeliverable_contact_name
      } else {
        return row.linked_edeliveries[0].edeliverable_contact_name
      }
    },
    extractEmailFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return 'Not Applicable'
      } else {
        return row.metadata ? row.metadata.email : 'N/A'
      }
    },
    extractDeliveryStatusFromRow (row) {
      if (row.entity_type === 'EDelivery') {
        return row.delivery_status
      } else {
        return row.event_status
      }
    },
    getClassByStatus (status) {
      return getEdeliveryRowCssStyleByStatus(status)
    },
    baEdeliverablesTableRowClassName ({row, rowIndex}) {
      let status = this.extractDeliveryStatusFromRow(row)
      return this.getClassByStatus(status)
    },
    getFitableTuples () {
    // returns tuples that fits this.policyNumber and this.fileInsuredName filtering
      let fittedTuples = []
      this.insuredsPolicyTuples.forEach(value => {
        let contactName = value[0]
        let policyName = value[1]
        if (this.policyNumber !== '' && !policyName.toLowerCase().includes(this.policyNumber.toLowerCase())) {
          return // continue cycle
        }
        if (this.fileInsuredName !== '' && !contactName.toLowerCase().includes(this.fileInsuredName.toLowerCase())) {
          return // continue cycle
        }
        fittedTuples.push(value)
      })
      return fittedTuples
    },
    extractSortedFieldList (fieldName, tuples) {
      // extracts value from tuple list, sorting and making list with values [{value: value}...]
      let indexToExtract = fieldName === 'policyNumber' ? 1 : 0
      let fitableTuples = tuples
      let policyNumbers = []
      fitableTuples.forEach(value => {
        let policyName = value[indexToExtract]
        if (!policyNumbers.includes(policyName)) {
          policyNumbers.push(policyName)
        }
      })
      policyNumbers.sort()
      let result = []
      policyNumbers.forEach(value => {
        result.push({value: value})
      })
      return result
    },

    queryPolicyNumberSearch (queryString, cb) {
      cb(this.extractSortedFieldList('policyNumber', this.getFitableTuples()))
    },
    queryPrimaryInsuredNameSearch (queryString, cb) {
      cb(this.extractSortedFieldList('contactName', this.getFitableTuples()))
    },
    clearFilter () {
      this.range.from = ''
      this.range.to = ''
      this.fileInsuredName = ''
      this.policyNumber = ''
      return this.loadPage(1)
    },
    loadInitial () {
      this.loadPage(1)
    },
    loadPage (page) {
      console.log('loadPage')
      this.loading = true
      let params = {
        per_page: this.perPage,
        page: page,
        show_processed_only: this.showProcessedOnly,
        edeliverable_contact_name: this.fileInsuredName,
        policy_number: this.policyNumber,
        order_by: this.orderBy,
      }
      if (this.range.from !== '') {
        params.from_date = convertDateToYYYYMMDD(this.range.from)
      }
      if (this.range.to !== '') {
        params.to_date = convertDateToYYYYMMDD(this.range.to)
      }
      axios.get(`${config.url}/company/${this.companyId}/get_edelivery_objects_for_user/`, {params: params})
        .then((ret) => {
          let responseData = ret.data.data
          let items = responseData.search_result.items
          items.forEach(
            (item) => {
              item.userEvents = []
              item.logs = ''
              item.showLogs = false
              item.showRawBCData = false
            }
          )
          this.items = items
          this.total = responseData.search_result.total
          this.perPage = responseData.search_result.page_size
          this.numPages = responseData.search_result.num_pages
          this.insuredsPolicyTuples = responseData.edeliverable_contact_names_policy_numbers_pairs
        })
        .finally(() => {
          this.loading = false
        })
    },
    downloadXlsReport () {
      let fromDate = convertDateToYYYYMMDD(this.range.from)
      let toDate = convertDateToYYYYMMDD(this.range.to)
      let url = `${config.url}/company/${this.companyId}/edelivery-report/?from_date=${fromDate}&to_date=${toDate}&token=${localStorage.carrierToken}`
      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
  .line-height-3 {
    line-height: 2em;
  }
</style>

<style lang="scss">
  .edelivery .el-pager li.active {
    color: #fff;
    background-color: #409EFF;
  }

  .edelivery-table {
    width: 100%;
    div.cell {
      word-break: break-word !important;
    }
    &__processed-column, &__delivery-status-column {
      & > div.cell {
        white-space: nowrap !important;
      }
    }
  }

  .linked-edeliverables-title {
    display: inline-block;
    vertical-align: top
  }
  .linked-edeliverables-body {
    display: inline-block;
  }

  .linked-user-events-border {
    border: 1px solid;
    border-radius:10px;
    padding: 5px
  }
  .schedule-info {
    color: red;
  }

  .reports-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }


</style>

